export default Object.freeze({
  REAPPLYING: 'Reapplying',
  RETAINING: 'Retaining',
  APPLYING: 'Applying',
});
